import { Box, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const NivelDesarrolloCompetencia = () => {
    const { promptData, setPromptData } = useActividadesContext();


    const handleNivelDesarrolloCompetencia = (event) => {
        const nivel_desarrollo_competencia = event.target.value;

        setPromptData((prevData) => ({
            ...prevData,
            nivel_desarrollo_competencia: nivel_desarrollo_competencia
        }));
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                    <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    ¿En qué nivel de desarrollo de la competencia se encuentran los niños y las niñas?
                    </Typography>
                </Box>
                <TextField
                    fullWidth
                    variant="outlined"
                    value={promptData.nivel_desarrollo_competencia}
                    onChange={handleNivelDesarrolloCompetencia}
                    InputProps={{
                        sx: {
                            mt: 1,
                            mb: 3,
                            fontFamily: 'montserrat',
                            fontSize: '11px',
                            color: '#005559',
                            '&::placeholder': {
                                color: '#005559',

                            },
                            '&:before': {
                                borderBottomColor: '#005559',

                            },
                            '&:after': {
                                borderBottomColor: '#005559',
                            },
                        }
                    }}
                />
            </Box>
        </Grid>
    );
};

export default NivelDesarrolloCompetencia;
